<app-content-header [actionBar]="[]" [currentNavItem]="currentNavItem" [breadcrumbs]="breadcrumbs" />
<app-grid
    [data]="query()"
    [buttons]="[]"
    [filterable]="false"
    [nrOfActiveFilters]="nrOfActiveFilters"
    [sort]="gridSort"
    [parentRoute]="parentRoute"
    [defaultViewMode]="defaultViewMode"
    [sortable]="true"
    [reorderable]="true"
    [resizable]="true"
    [autoFitColumns]="false"
    (clearFilter)="clearFilter()"
    (pageChange)="search()"
    (saveGridSettings)="saveGridSettings($event)"
    (deleteGridSettings)="deleteGridSettings()"
    (toggleFilter)="filterDialog(filterProperties, { width: '40%' })">
    <kendo-grid-column title="{{ 'Message' | translate }}" [width]="120">
        <ng-template kendoGridCellTemplate let-item>
            <div class="flex size-full items-center justify-center">
                <app-button
                    variant="primary"
                    icon="faSolidEye"
                    [tooltip]="'View Message' | translate"
                    (clicked)="openMessageDialog(item.message)" />
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{ 'Message type' | translate }}" field="messageType"></kendo-grid-column>
    <kendo-grid-column title="{{ 'IMO' | translate }}" field="vesselImo"></kendo-grid-column>
    <kendo-grid-column title="{{ 'Error' | translate }}" field="error">
        <ng-template kendoGridCellTemplate let-item>
            <app-control type="boolean" [isDisabled]="true" [ngModel]="item.error" />
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="{{ 'Created Date' | translate }}" field="createdDate">
        <ng-template kendoGridCellTemplate let-item>
            {{ item.createdDate | datetime }}
        </ng-template>
    </kendo-grid-column>
</app-grid>
